export const PROGRAM_OPTIONS = [
  { value: "spirit", label: "Spirit (Dance, Cheer, Pep Squad)" },
  { value: "theatre", label: "Theatre" },
];
export const PROGRAM_LABEL = { spirit: "Spirit", theatre: "Theatre" };

const THEATRE_WORDS = ["theatre", "theater", "drama", "thespian", "musical"];

// Mirrors backend routers/bios.detect_program: theatre-sounding names -> theatre, else spirit.
export const detectProgram = (name) => (THEATRE_WORDS.some((w) => (name || "").toLowerCase().includes(w)) ? "theatre" : "spirit");
